import BrownRiceProduct from 'models/BrownRiceProduct'

export const oatCookingTypeOptions = [
  {
    value: '',
    label: 'Cooking Type',
    isDisabled: true,
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Quick', label: 'Quick' },
  { value: 'Instant', label: 'Instant' },
]

export const oatVarietyOptions = [
  {
    value: '',
    label: 'Variety',
    isDisabled: true,
  },
  { value: 'Regular', label: 'Regular' },
  { value: 'Basmati Brown', label: 'Basmati Brown' },
  { value: 'Jasmine Brown', label: 'Jasmine Brown' },
  { value: 'Other', label: 'Other' },
]

export const grainLengthOptions = [
  {
    value: '',
    label: 'Grain Length',
    isDisabled: true,
  },
  { value: 'Short', label: 'Short' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Long', label: 'Long' },
  { value: 'Extra Long', label: 'Extra Long' },
]

export const packagingInitialState = {
  category: BrownRiceProduct.category,
  subCategory: BrownRiceProduct.subCategory,
  GrainSize: '',
  CookingType: {
    value: oatCookingTypeOptions[0].value,
    label: oatCookingTypeOptions[0].label,
  },
  OatVariety: {
    value: oatVarietyOptions[0].value,
    label: oatVarietyOptions[0].label,
  },
  GrainLength: {
    value: grainLengthOptions[0].value,
    label: grainLengthOptions[0].label,
  },
  otherType: '',
}
